import React from "react";
import { Link } from "react-router-dom";
import AboutImg from "../Assets/img/about-img.png";
import NoticeBoardSection from "./NoticeBoardSection";
const AboutSection = () => {
  return (
    <>
      <section className="eschool-about">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="eschool-about-main">
                <div className="eschool-about-main-img">
                  <img src={AboutImg} alt="#" />
                </div>
                <div className="eschool-about-content">
                  <h3 className="eschool-about-cont-title">
                    About X Model High School Dhaka
                  </h3>
                  <p className="eschool-about-cont-text">
                    X Model High School Dhaka, with its commitment to an
                    experiential project-based pedagogy and integrated
                    curriculum, has established a formidable reputation for
                    itself as a progressive, innovative school in just over a
                    decade that it has been operational.
                  </p>
                  <p className="eschool-about-cont-text m-0">
                    {" "}
                    It stands apart as perhaps the only example of a progressive
                    school that offers alternate education in the mainstream,
                    disproving the perception that experiential education can
                    only take place on a small scale. XMHS has regularly found
                    representation in the top 10 schools of Bangladesh as much
                    for its academic reputation and infrastructure, as for its
                    focus on students with special needs or those from
                    economically weaker sections.Other areas where the school
                    has been cited for excellence include co-curricular
                    activity, leadership and management, sports education, life
                    skills education and conflict resolution, and parent
                    involvement.
                  </p>
                  <div className="eschool-about-cont-btn">
                    <Link to="/aboutus" className="eschool-btn secondary-btn">
                      More details<i className="fi fi-rs-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-6 col-12">
              <NoticeBoardSection />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
